export default __webpack_public_path__ + "544bdd36a7e981002bc586b5c77e68c6.png";